import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Milestone from '../Milestone';
import Watermark from '../Watermark';

const FoldCard = ({ content }) => {
    const { title, milestone, watermark } = content;

    return (
        <div className={styles.wrap}>
            <div className={styles.title}>
                <Milestone id={milestone} />
                <span className={styles.titleText}>{title}</span>
            </div>
            <Watermark id={watermark} />
        </div>
    );
};

FoldCard.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(FoldCard);
